import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { useEscapeKey } from '../../hooks/useEscapeKey';
import IconButton from './IconButton';

const WIDTHS = { sm: 'max-w-sm', md: 'max-w-md' };

// Shared modal shell: backdrop + centered panel + header with close button.
// Content goes into the scrollable body. maxWidth: 'sm' | 'md'.
function Modal({ open, title, onClose, maxWidth = 'sm', children }) {
  const { t } = useTranslation();
  useEscapeKey(open, onClose);

  if (!open) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-40" role="dialog" aria-modal="true" aria-label={title}>
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />
      <div className={`absolute left-1/2 top-1/2 w-[calc(100%-2rem)] ${WIDTHS[maxWidth]} -translate-x-1/2 -translate-y-1/2`}>
        <div className="flex max-h-[calc(100dvh-2rem)] flex-col overflow-hidden rounded-lg border border-[color:var(--app-border)] bg-[color:var(--app-surface)] shadow-lg">
          <div className="flex items-center justify-between border-b border-[color:var(--app-border)] px-4 py-3">
            <h2 className="text-base font-semibold">{title}</h2>
            <IconButton icon={faXmark} label={t('settings.close')} onClick={onClose} size="md" tone="muted" iconClass="text-sm" />
          </div>
          <div className="min-h-0 overflow-y-auto p-4 pt-3">{children}</div>
        </div>
      </div>
    </div>
  );
}

export default Modal;
